import { EmptyState } from '../ui'

/**
 * Offers received, offers sent, confirmed swaps (PLAN.md §8). Placeholder
 * until later phases bring auth and the swap flow.
 */
export function SwapsScreen() {
  return (
    <EmptyState
      title="No swaps yet"
      body="Offers you send and receive will show up here — accept, decline or withdraw, and every confirmed swap gets a reminder to tell workforce planning."
    />
  )
}
